const translations = {
  // Hero Section
  "unlock_cosmic": "श्री एस्ट्रो वेदा",
  "personalized_predictions": "राशि चिन्हों से लेकर जीवन के बड़े उत्तर तक",
  "hero_description": "जहाँ प्राचीन ज्ञान आपके आधुनिक जीवन से मिलता है — जन्म कुंडली, अंक ज्योतिष, प्रेम जीवन और दशा फल रीडिंग, सभी प्रमाणित ज्योतिष विशेषज्ञों द्वारा स्पष्टता और उद्देश्य के साथ आपके मार्गदर्शन के लिए तैयार की गई।",
  "get_my_report": "पूरा रिपोर्ट प्राप्त करें",
  "view_sample": "नमूना रिपोर्ट देखें",

  // Features
  "detailed_reports": "2026 व्यक्तिगत जीवन रिपोर्ट",
  "horoscope_matching": "कुंडली मिलान",
  "astrology_systems": "जन्म कुंडली, अंक ज्योतिष, दशा और अधिक",

  // Modal
  "200_pages": "200+ ज्ञानवर्धक पृष्ठ",
  "20_years_predictions": "20 वर्षों की भविष्यवाणियाँ",
  "personalized_kundli": "आपकी व्यक्तिगत वैदिक जीवन रिपोर्ट",
  "most_detailed_india": "पूर्ण और व्यापक मार्गदर्शन",
  "cosmic_blueprint_description": "आपकी जीवन यात्रा का रहस्योद्घाटन:",

  "predictions_doshas_remedies": "जन्म कुंडली, दशा, नक्षत्र, अंक ज्योतिष, लाल किताब, प्रेम जीवन, करियर, स्वास्थ्य सूचकांक, साढ़े साती, उपाय और अधिक पर विस्तृत जानकारी।",
  "customized_for_you": "आपके लिए विशेष रूप से तैयार की गई दिव्य रिपोर्ट - श्री एस्ट्रो वेदा",
  "check_sample_kundli": "रिपोर्ट देखें",

  // Section Title & Description
  "authentic_vedic_astrology": "श्रीएस्ट्रोवेद ज्योतिष सेवाएं",
  "cosmic_destiny": "आपका भाग्य, समझाया गया और",
  "through_ancient_wisdom": "वैदिक ज्योतिष के शाश्वत ज्ञान से मार्गदर्शित",
  "two_section_description": "श्रीएस्ट्रोवेद आपको प्राचीन ज्योतिष विज्ञान के माध्यम से जीवन के सही निर्णय लेने में मदद करता है — जिसमें विस्तृत कुंडली विश्लेषण, अंक ज्योतिष, दशा समयरेखा, प्रेम जीवन और शक्तिशाली लाल किताब के उपाय शामिल हैं। स्पष्टता और आत्मविश्वास के साथ अपना मार्ग खोजें।",

  // Features – focused on user benefits
  "personalized_birth_charts": "अपने सच्चे व्यक्तित्व को समझें",
  "personalized_birth_charts_desc": "अपनी जन्म कुंडली, लग्न और ग्रहों की स्थिति का संपूर्ण विश्लेषण प्राप्त करें, जिससे छिपी हुई ताकतें, कमजोरियाँ और जीवन के पैटर्न सामने आएं।",

  "remedial_gemstone_guidance": "जीवन की बाधाओं को दूर करें",
  "remedial_gemstone_guidance_desc": "प्रभावी उपाय, रत्न सुझाव और साढ़े साती विश्लेषण प्राप्त करें ताकि ग्रहों के असंतुलन को समाप्त किया जा सके और सकारात्मक परिणाम आकर्षित किए जा सकें।",

  "marriage_compatibility_analysis": "सुखद संबंध खोजें",
  "marriage_compatibility_analysis_desc": "हमारे उन्नत प्रेम और विवाह संगतता टूल का उपयोग करके संबंधों की गतिशीलता को समझें और दीर्घकालिक अनुकूलता सुनिश्चित करें।",

  "career_life_predictions": "आत्मविश्वास के साथ अपना भविष्य योजनाबद्ध करें",
  "career_life_predictions_desc": "करियर, स्वास्थ्य, वित्त और वार्षिक प्रवृत्तियों के बारे में सटीक भविष्यवाणियाँ प्राप्त करें ताकि आप पहले से योजना बना सकें और सशक्त निर्णय ले सकें।",

  // CTA & Trust
  "start_your_journey": "अपना राशि पथ खोलें",
  "learn_more": "पूर्ण सेवाएं देखें",
  "rated_by_clients": "10,000+ ग्राहकों द्वारा 4.9/5 रेटेड",
  "confidential_secure": "100% गोपनीय और सुरक्षित",

  "authentic_astrology_banner": "प्रामाणिक ज्योतिष सेवाएं",

  "match_kundli": "कुंडली मिलान",
  "match_kundli_desc": "अपने और अपने साथी के लिए विवाह संगतता और कुंडली मिलान जांचें।",
  "match_now": "अभी मिलान करें",

  "your_life_predictions": "आपकी जीवन भविष्यवाणी",
  "life_predictions_desc": "अपनी जन्म कुंडली के आधार पर अपने भविष्य का संपूर्ण अवलोकन प्राप्त करें।",
  "view_predictions": "भविष्यवाणी देखें",

  "ask_question_price": "एक प्रश्न पूछें",
  "ask_question_desc": "किसी भी व्यक्तिगत या आवश्यक प्रश्न का विशेषज्ञ उत्तर प्राप्त करें।",
  "ask_now": "अभी पूछें",

  "career_guidance": "करियर",
  "career_desc": "अपने सितारों के अनुसार सही करियर पथ और नौकरी के अवसर खोजें।",
  "explore_career": "करियर खोजें",

  "love_compatibility": "प्रेम",
  "love_desc": "जानिए अपने प्रेम जीवन की दिशा, संबंधों की सच्ची संगतता और उज्जवल भविष्य के सुनहरे अवसर।",
  "check_love_life": "प्रेम जीवन जांचें",

  "2026_personalized_report": "2026 व्यक्तिगत रिपोर्ट",
  "2026_report_desc": "आपके जन्म विवरण के अनुसार विस्तृत वार्षिक पूर्वानुमान।",
  "get_2026_report": "2026 रिपोर्ट प्राप्त करें",

  "dasha_phal_analysis": "दशा फल विश्लेषण",
  "dasha_analysis_desc": "अपने जीवन पर ग्रहों की दशाओं के प्रभाव को समझें।",
  "analyze_now": "अभी विश्लेषण करें",

  "sade_sati_report": "साढ़े साती जीवन रिपोर्ट",
  "sade_sati_desc": "जानें कि शनि की साढ़े साती आपको कैसे प्रभावित करेगी और उपाय प्राप्त करें।",
  "check_sade_sati": "साढ़े साती जांचें",

  // Horoscope section
  "free_daily_horoscope": "हर राशि, हर राज़ – जानें सितारे आपके बारे में क्या कहते हैं",
  "horoscope_categories": "",

  // Zodiac signs
  "aries": "मेष",
  "taurus": "वृषभ",
  "gemini": "मिथुन",
  "cancer": "कर्क",
  "leo": "सिंह",
  "virgo": "कन्या",
  "libra": "तुला",
  "scorpio": "वृश्चिक",
  "sagittarius": "धनु",
  "capricorn": "मकर",
  "aquarius": "कुंभ",
  "pisces": "मीन",

  // Date ranges
  "aries_dates": "21 मार्च - 19 अप्रैल",
  "taurus_dates": "20 अप्रैल - 20 मई",
  "gemini_dates": "21 मई - 20 जून",
  "cancer_dates": "21 जून - 22 जुलाई",
  "leo_dates": "23 जुलाई - 22 अगस्त",
  "virgo_dates": "23 अगस्त - 22 सितम्बर",
  "libra_dates": "23 सितम्बर - 22 अक्टूबर",
  "scorpio_dates": "23 अक्टूबर - 21 नवम्बर",
  "sagittarius_dates": "22 नवम्बर - 21 दिसम्बर",
  "capricorn_dates": "22 दिसम्बर - 19 जनवरी",
  "aquarius_dates": "20 जनवरी - 18 फरवरी",
  "pisces_dates": "19 फरवरी - 20 मार्च",

  // Modal content keys
  "today_horoscope": "आज का राशिफल",
  "basic_info": "मूल जानकारी",
  "characteristics": "विशेषताएँ",
  "lucky_elements": "शुभ तत्व",
  "lucky_color": "शुभ रंग",
  "lucky_number": "शुभ अंक",
  "element": "तत्व",
  "ruling_planet": "स्वामी ग्रह",
  "get_detailed_reading": "विस्तृत रीडिंग प्राप्त करें",
  "more_insights": "अधिक जानकारी",
  "likes": "पसंद",
  "dislikes": "नापसंद",
  "food": "भोजन",
  "travel_style": "यात्रा शैली",
  "movie_match": "फिल्म मैच",
  "song_vibe": "गीत मूड",
  "celebs": "प्रसिद्ध व्यक्तित्व",

  // Aries content
  "aries_horoscope": "आज ऊर्जावान और नए अवसरों से भरपूर दिन है। आपकी नेतृत्व क्षमता चमकेगी, नए प्रोजेक्ट शुरू करने या परिस्थितियों का नेतृत्व करने के लिए उत्तम समय है।",
  "aries_traits": "निडर, प्रतिस्पर्धी, ऊर्जा और पहल से भरपूर। हमेशा कार्य करने में सबसे आगे।",
  "aries_likes": "जीतना, नेतृत्व, रोमांच, चुनौतियाँ।",
  "aries_dislikes": "आलस्य, देरी, अनिर्णय।",
  "aries_food": "मसालेदार भोजन, ग्रिल्ड मीट, प्रोटीन युक्त व्यंजन।",
  "aries_travel_style": "एडवेंचर स्पोर्ट्स, सोलो ट्रेकिंग, रोड ट्रिप।",
  "aries_movie_match": "मैड मैक्स: फ्यूरी रोड",
  "aries_song_vibe": "आई ऑफ द टाइगर",
  "aries_celebs": "लेडी गागा, अजय देवगन, रॉबर्ट डाउनी जूनियर",
  "aries_color": "लाल",
  "aries_number": "9",
  "aries_element": "अग्नि",
  "aries_planet": "मंगल",

  "taurus_horoscope": "आज का दिन आराम और सुख के लिए है। स्थिरता पर ध्यान दें और जीवन की अच्छी चीजों का आनंद लें। आपका धैर्य आपको लंबे समय तक टिकने वाले परिणाम देगा।",
  "taurus_traits": "शांत, भरोसेमंद, संवेदनशील, वफ़ादार। आराम और विलासिता पसंद।",
  "taurus_likes": "प्रकृति, संगीत, अच्छा भोजन, सुंदर चीजें।",
  "taurus_dislikes": "अचानक बदलाव, जल्दीबाज़ी, अस्थिरता।",
  "taurus_food": "समृद्ध भोजन, मिठाइयाँ, गॉरमेट चीज़, चॉकलेट।",
  "taurus_travel_style": "प्रकृति रिट्रीट, अंगूर के बाग, लग्ज़री रिसॉर्ट।",
  "taurus_movie_match": "द हंड्रेड-फुट जर्नी",
  "taurus_song_vibe": "ऑल ऑफ मी",
  "taurus_celebs": "गीगी हदीद, वरुण धवन, अडेल",
  "taurus_color": "हरा और गुलाबी",
  "taurus_number": "6",
  "taurus_element": "पृथ्वी",
  "taurus_planet": "शुक्र",

  "gemini_horoscope": "आज संवाद सबसे महत्वपूर्ण है। आपकी बुद्धिमत्ता और अनुकूलन क्षमता नए अवसर खोलेगी। नेटवर्किंग और विचार साझा करने का सही समय है।",
  "gemini_traits": "मिलनसार, बुद्धिमान, अनुकूलनशील, तेज़ सोचने वाले, मल्टी-टास्कर।",
  "gemini_likes": "बात करना, लिखना, तकनीक, नए अनुभव।",
  "gemini_dislikes": "दोहराव, बोरियत, चुप्पी।",
  "gemini_food": "फिंगर फूड, स्ट्रीट स्नैक्स, अनोखे व्यंजन।",
  "gemini_travel_style": "छोटी अचानक यात्राएं, शहर की खोज।",
  "gemini_movie_match": "द सोशल नेटवर्क",
  "gemini_song_vibe": "लेविटेटिंग",
  "gemini_celebs": "एंजेलिना जोली, करण जौहर, कान्ये वेस्ट",
  "gemini_color": "पीला",
  "gemini_number": "5",
  "gemini_element": "वायु",
  "gemini_planet": "बुध",

  "cancer_horoscope": "आज अपनी अंतर्दृष्टि पर भरोसा करें। परिवार और घर के मामलों को प्राथमिकता दें। आपकी देखभाल करने वाली प्रकृति दूसरों को सुकून देगी।",
  "cancer_traits": "भावुक, देखभाल करने वाले, अंतर्ज्ञानी, परिवार-प्रिय।",
  "cancer_likes": "घर, आरामदायक भोजन, यादें, करीबी दोस्त।",
  "cancer_dislikes": "कठोरता, त्याग, बदलाव।",
  "cancer_food": "घर का खाना, चावल के व्यंजन, मिठाइयाँ।",
  "cancer_travel_style": "बीच हाउस, पुश्तैनी स्थान, आध्यात्मिक स्थल।",
  "cancer_movie_match": "द नोटबुक",
  "cancer_song_vibe": "फोटोग्राफ",
  "cancer_celebs": "सेलेना गोमेज़, प्रियंका चोपड़ा, टॉम हैंक्स",
  "cancer_color": "सफेद और चाँदी",
  "cancer_number": "2",
  "cancer_element": "जल",
  "cancer_planet": "चंद्रमा",

  "leo_horoscope": "आपका स्वाभाविक करिश्मा आज चमक रहा है। मंच पर आएं और अपनी रचनात्मकता को बहने दें। प्रशंसा और सम्मान मिलने वाला है।",
  "leo_traits": "साहसी, नाटकीय, गर्मदिल, जन्मजात नेता। ध्यान पसंद।",
  "leo_likes": "ग्लैमर, मंच, जश्न, नेतृत्व।",
  "leo_dislikes": "अनदेखा होना, नीरसता, आलोचना।",
  "leo_food": "ग्रिल्ड फूड, समृद्ध मिठाइयाँ, विदेशी व्यंजन।",
  "leo_travel_style": "लक्ज़री क्रूज़, सांस्कृतिक परेड, आकर्षक जगहें।",
  "leo_movie_match": "द ग्रेट गैट्सबी",
  "leo_song_vibe": "अपटाउन फंक",
  "leo_celebs": "जेनिफर लोपेज, सैफ अली खान, बराक ओबामा",
  "leo_color": "सोना और नारंगी",
  "leo_number": "1",
  "leo_element": "अग्नि",
  "leo_planet": "सूर्य",

  "virgo_horoscope": "विवरण पर ध्यान आज काम आएगा। आपकी विश्लेषण क्षमता जटिल समस्याओं का समाधान करेगी। स्वास्थ्य और संगठन पर ध्यान दें।",
  "virgo_traits": "परफेक्शनिस्ट, व्यावहारिक, बुद्धिमान, स्वास्थ्य-सचेत।",
  "virgo_likes": "सफाई, योजना, मदद करना, सीखना।",
  "virgo_dislikes": "अव्यवस्था, अक्षम्यता, भावनात्मक विस्फोट।",
  "virgo_food": "हेल्दी बाउल, क्लीन ईटिंग, सूप, सलाद।",
  "virgo_travel_style": "वेलनेस रिसॉर्ट, इको स्टे, विरासत स्थल।",
  "virgo_movie_match": "द इमिटेशन गेम",
  "virgo_song_vibe": "लवली",
  "virgo_celebs": "कियानू रीव्स, करीना कपूर, ज़ेन्डाया",
  "virgo_color": "सफेद और मिट्टी के रंग",
  "virgo_number": "6",
  "virgo_element": "पृथ्वी",
  "virgo_planet": "बुध",

  "libra_horoscope": "संतुलन और सामंजस्य आपका मार्गदर्शन कर रहे हैं। रिश्तों में न्याय और सुंदरता पर ध्यान दें। कला से जुड़े कार्य खुशी देंगे।",
  "libra_traits": "सौम्य, न्यायप्रिय, रोमांटिक, शांति-प्रिय, सौंदर्य प्रेमी।",
  "libra_likes": "कला, फैशन, रोमांस, बातचीत।",
  "libra_dislikes": "असभ्यता, झगड़े, असंतुलन।",
  "libra_food": "पेस्ट्री, वाइन, चीज़, हल्की पास्ता।",
  "libra_travel_style": "पेरिस, वेनिस, रोमांटिक या फैशन स्थल।",
  "libra_movie_match": "ला ला लैंड",
  "libra_song_vibe": "जस्ट द वे यू आर",
  "libra_celebs": "किम कार्दशियन, रणबीर कपूर, ह्यू जैकमैन",
  "libra_color": "आसमान नीला और गुलाबी",
  "libra_number": "7",
  "libra_element": "वायु",
  "libra_planet": "शुक्र",

  "scorpio_horoscope": "गहरा बदलाव वातावरण में है। अपने अंतर्ज्ञान पर भरोसा करें और बदलाव को अपनाएं। आपका जुनून आपको नई ऊँचाइयों तक ले जाएगा।",
  "scorpio_traits": "रहस्यमयी, गहन, वफ़ादार, भावनात्मक।",
  "scorpio_likes": "राज़, बदलाव, जुनून।",
  "scorpio_dislikes": "बेईमानी, उथले लोग, धोखा।",
  "scorpio_food": "मसालेदार, गहरे स्वाद, डार्क चॉकलेट, रहस्यमयी व्यंजन।",
  "scorpio_travel_style": "छिपे स्थान, गुफाएँ, गुप्त समुद्र तट।",
  "scorpio_movie_match": "गॉन गर्ल",
  "scorpio_song_vibe": "टेक मी टू चर्च",
  "scorpio_celebs": "रायन गॉसलिंग, शाहरुख खान, केटी पेरी",
  "scorpio_color": "काला और गहरा लाल",
  "scorpio_number": "8",
  "scorpio_element": "जल",
  "scorpio_planet": "मंगल और प्लूटो",

  "sagittarius_horoscope": "आज रोमांच आपको पुकार रहा है। सीखने या यात्रा के माध्यम से अपने दृष्टिकोण को व्यापक करें। आपका आशावाद दूसरों को बड़े सपने देखने के लिए प्रेरित करता है।",
  "sagittarius_traits": "स्वतंत्र विचारधारा, मज़ाकिया, दार्शनिक, आशावादी।",
  "sagittarius_likes": "यात्रा, रोमांच, सत्य, गहन बातचीत।",
  "sagittarius_dislikes": "नियम-कायदें, चिपकूपन, रोज़मर्रा की एकरूपता।",
  "sagittarius_food": "स्ट्रीट फूड, बारबेक्यू, अंतरराष्ट्रीय व्यंजन।",
  "sagittarius_travel_style": "बैगपैकिंग, अनजानी यात्राएं, अकेले ट्रिप।",
  "sagittarius_movie_match": "Into the Wild",
  "sagittarius_song_vibe": "Adventure of a Lifetime",
  "sagittarius_celebs": "टेलर स्विफ्ट, धर्मेंद्र, ब्रैड पिट",
  "sagittarius_color": "बैंगनी और फ़िरोज़ी",
  "sagittarius_number": "9",
  "sagittarius_element": "अग्नि",
  "sagittarius_planet": "बृहस्पति",

  "capricorn_horoscope": "कड़ी मेहनत और अनुशासन आज सफलता लाएंगे। आपका व्यवस्थित दृष्टिकोण दीर्घकालिक उपलब्धियों के द्वार खोलेगा। अपने लक्ष्यों पर ध्यान केंद्रित रखें।",
  "capricorn_traits": "महत्त्वाकांक्षी, परिपक्व, अनुशासित, शाश्वत।",
  "capricorn_likes": "सफलता, व्यवस्था, निष्ठा, परंपराएं।",
  "capricorn_dislikes": "आलस्य, बेईमानी, शॉर्टकट।",
  "capricorn_food": "पारंपरिक भोजन, सूप, ब्रेड, धीमी आंच पर पका खाना।",
  "capricorn_travel_style": "पहाड़, ऐतिहासिक शहर, व्यवसाय+मनोरंजन यात्राएं।",
  "capricorn_movie_match": "The Pursuit of Happyness",
  "capricorn_song_vibe": "Hall of Fame",
  "capricorn_celebs": "दीपिका पादुकोण, ऋतिक रोशन, मिशेल ओबामा",
  "capricorn_color": "नेवी और भूरा",
  "capricorn_number": "10",
  "capricorn_element": "पृथ्वी",
  "capricorn_planet": "शनि",

  "aquarius_horoscope": "नवाचार और मानवीय प्रयास आज केंद्र में हैं। आपका अनोखा दृष्टिकोण पुराने समस्याओं के नए समाधान लाता है। सीमाओं से बाहर सोचें।",
  "aquarius_traits": "दूरदर्शी, स्वतंत्र, असामान्य, मानवीय।",
  "aquarius_likes": "नवाचार, सामाजिक कार्य, विचार, समुदाय।",
  "aquarius_dislikes": "प्रतिबंध, रूढ़िवादिता, एकरूप दिनचर्या।",
  "aquarius_food": "शाकाहारी/प्लांट-बेस्ड, फ्यूज़न फूड, स्मूदी।",
  "aquarius_travel_style": "भविष्यवादी शहर, वालंटियर टूरिज्म, उद्देश्यपूर्ण रोड ट्रिप।",
  "aquarius_movie_match": "The Matrix",
  "aquarius_song_vibe": "Radioactive",
  "aquarius_celebs": "ओप्रा विनफ्रे, प्रीति जिंटा, हैरी स्टाइल्स",
  "aquarius_color": "इलेक्ट्रिक नीला और एक्वा",
  "aquarius_number": "11",
  "aquarius_element": "वायु",
  "aquarius_planet": "यूरेनस और शनि",

  "pisces_horoscope": "आज अपनी कल्पनाओं को बहने दें। सपने और अंतर्ज्ञान आपको सुंदर खोजों की ओर ले जाएंगे। आपका दयालु स्वभाव कई दिलों को छू लेता है।",
  "pisces_traits": "सहानुभूतिपूर्ण, स्वप्नदर्शी, कलात्मक, सहज ज्ञानयुक्त।",
  "pisces_likes": "कला, प्रेम कहानियां, संगीत, सपने।",
  "pisces_dislikes": "कठोर वास्तविकताएं, शोरगुल वाली भीड़, टकराव।",
  "pisces_food": "सीफ़ूड, पास्ता, आरामदायक खाना, आइसक्रीम।",
  "pisces_travel_style": "द्वीप, रिट्रीट, नदी किनारे सैर।",
  "pisces_movie_match": "Life of Pi",
  "pisces_song_vibe": "Someone Like You",
  "pisces_celebs": "रिहाना, आलिया भट्ट, जस्टिन बीबर",
  "pisces_color": "लैवेंडर और सी ग्रीन",
  "pisces_number": "12",
  "pisces_element": "जल",
  "pisces_planet": "नेपच्यून और बृहस्पति",

  "review_title": "ऊर्जा का आदान-प्रदान: उनके शब्द, हमारा आभार",

  "why_choose": "श्रीएस्ट्रोवेदा क्यों चुनें",

  "unlimited_kundlis_question": "क्या मैं कई कुंडलियां मंगा सकता हूँ?",
  "unlimited_kundlis_answer": "हाँ! आप जितने चाहें लोगों के विवरण भेज सकते हैं। हर अनुरोध को सावधानीपूर्वक तैयार किया जाएगा और एक व्यक्तिगत PDF रिपोर्ट के रूप में भेजा जाएगा।",

  "kundli_reports_question": "कुंडली रिपोर्ट में क्या-क्या शामिल है?",
  "kundli_reports_answer": "हर रिपोर्ट एक **व्यावसायिक रूप से तैयार PDF** होती है जिसमें जन्म कुंडली, लग्न विश्लेषण, दशा, गोचर, नक्षत्र, अंक ज्योतिष, प्रेम और करियर मार्गदर्शन, स्वास्थ्य सूचकांक, लाल किताब के उपाय और बहुत कुछ शामिल है।",

  "saving_notes_question": "क्या मैं सेशन नोट्स या उपाय जोड़ सकता हूँ?",
  "saving_notes_answer": "बिलकुल। अगर आप विशेष उपाय, फॉलो-अप नोट्स या अतिरिक्त टिप्पणियां जोड़ना चाहते हैं, तो अनुरोध के समय हमें बताएं।",

  "devices_question": "मुझे रिपोर्ट कैसे प्राप्त होगी?",
  "devices_answer": "आपको रिपोर्ट **24 घंटे के भीतर** PDF फॉर्मेट में **व्हाट्सएप, ईमेल या SMS** के जरिए मिलेगी — जैसा आप चाहें।",

  "data_safety_question": "क्या मेरी निजी जानकारी सुरक्षित है?",
  "data_safety_answer": "हाँ। सभी यूज़र डेटा को **पूरी तरह गोपनीय** रखा जाता है और कभी साझा नहीं किया जाता। आपकी प्राइवेसी और भरोसा हमारी सर्वोच्च प्राथमिकता है।",

  "advertising_question": "क्या रिपोर्ट में कोई विज्ञापन है?",
  "advertising_answer": "**100% विज्ञापन-मुक्त।** हमारी रिपोर्टें केवल शुद्ध और केंद्रित ज्योतिषीय ज्ञान देती हैं, बिना किसी प्रचार सामग्री के।",

  "client_management_question": "क्या मैं अपने ग्राहकों के लिए रिपोर्ट ऑर्डर कर सकता हूँ?",
  "client_management_answer": "हाँ! चाहे आप ज्योतिषी हों, सलाहकार हों या वेलनेस कोच — आप अपने ग्राहकों के लिए व्यक्तिगत रिपोर्ट मंगवा सकते हैं। हम थोक और नियमित ऑर्डर भी लेते हैं।",

  "customize_charts_question": "क्या मैं चार्ट का स्टाइल या लेआउट चुन सकता हूँ?",
  "customize_charts_answer": "हाँ। हम **उत्तर, दक्षिण और पूर्व भारतीय चार्ट फॉर्मेट** प्रदान करते हैं। आप चाहें तो फ़ॉन्ट साइज और रंग की पसंद भी बता सकते हैं।",

  "discounts_question": "क्या कोई डिस्काउंट उपलब्ध है?",
  "discounts_answer": "हाँ। हम **मौसमी छूट**, **कॉम्बो ऑफ़र** और ज्योतिषियों व नियमित ग्राहकों के लिए विशेष दरें देते हैं। अपडेट के लिए व्हाट्सएप से जुड़े रहें।",

  "affiliate_question": "क्या मैं दूसरों को रेफ़र करके कमा सकता हूँ?",
  "affiliate_answer": "हाँ! **श्रीएस्ट्रोवेदा एफिलिएट प्रोग्राम** से जुड़ें और दोस्तों, ग्राहकों या अपने ऑडियंस को रेफ़र करके कमीशन कमाएं।",

  "languages_question": "क्या रिपोर्ट क्षेत्रीय भाषाओं में उपलब्ध है?",
  "languages_answer": "हाँ। हम रिपोर्ट **हिंदी, अंग्रेज़ी, तेलुगु, कन्नड़, तमिल, मराठी, बंगाली** और अन्य क्षेत्रीय भाषाओं में उपलब्ध कराते हैं।",

  "delivery_time_question": "मुझे रिपोर्ट कितनी जल्दी मिलेगी?",
  "delivery_time_answer": "आपके विवरण भेजने के **24 घंटे के भीतर** पूरी रिपोर्ट आपको मिल जाएगी। डिलीवरी व्हाट्सएप, ईमेल या SMS से होगी।",

  "services_question": "कौन-कौन सी ज्योतिष सेवाएं शामिल हैं?",
  "services_answer": "हमारी रिपोर्ट में शामिल हैं: **जन्म कुंडली, कुंडली मिलान, लग्न और दशा विश्लेषण, गोचर, नक्षत्र, अंक ज्योतिष, करियर और प्रेम मार्गदर्शन, वार्षिक और दैनिक भविष्यवाणी, स्वास्थ्य सूचकांक, लाल किताब उपाय, साढ़ेसाती रिपोर्ट, दोष विश्लेषण, रत्न सुझाव** और बहुत कुछ।",

  "unmute_first_card": "पहला कार्ड अनम्यूट करें",
  "mute_first_card": "पहला कार्ड म्यूट करें"


};

export default translations;
